<div class="row justify-content-center">
  <div class="col-11">
    <div class="row details">
      <div class="col-12 thicc">
        <span>Description</span>
        <cyborg-markdown
          *ngIf="data?.description"
          [md]="data?.description"
        ></cyborg-markdown>
        <p *ngIf="!data?.description">--</p>
      </div>
      <div class="col-3">
        <span>Created</span>
        <p>{{ data?.created_date | date }}</p>
      </div>
      <div class="col-3">
        <span>Last Updated</span>
        <p>{{ data?.last_updated | date }}</p>
      </div>
      <div class="col-3">
        <span>Severity</span>
        <p>{{ data?.severity }}</p>
      </div>
      <ng-container *ngIf="threatProfiles$ | async as threatProfile">
        <ng-container *ngIf="threatProfile.length > 0; else noLink">
          <div class="col-3">
            <span>Threat Names</span>
            <p>
              <span *ngFor="let threat of threatProfile; let isLast = last">
                <a
                  routerLink="/research/threat-profile/{{ threat.profile_id }}"
                  >{{ threat.profile_name }}</a
                ><span>{{ isLast ? '' : ', &nbsp;' }}</span>
              </span>
            </p>
          </div>
        </ng-container>
      </ng-container>
      <ng-template #noLink>
        <div class="col-3">
          <span>Threat Names</span>
          <p>
            {{ data?.context.threat_names.join(', ') }}
          </p>
        </div>
      </ng-template>
      <div class="col-3" *ngIf="data?.context?.threat_categories?.length > 0">
        <span>Threat Categories</span>
        <p>
          {{ data?.context.threat_categories.join(', ') }}
        </p>
      </div>
      <div class="col-3" *ngIf="data?.context?.threat_types?.length > 0">
        <span>Threat Types</span>
        <p>
          {{ data?.context.threat_types.join(', ') }}
        </p>
      </div>
      <div class="col-3" *ngIf="data?.context?.source_regions?.length > 0">
        <span>Source Regions</span>
        <p>
          {{ data?.context.source_regions.join(', ') }}
        </p>
      </div>
      <div class="col-3" *ngIf="data?.context?.source_countries?.length > 0">
        <span>Source Countries</span>
        <p>
          {{ data?.context.source_countries.join(', ') }}
        </p>
      </div>
      <div class="col-3" *ngIf="data?.context?.actors?.length > 0">
        <span>Actors</span>
        <p>
          {{ data?.context.actors.join(', ') }}
        </p>
      </div>

      <div class="col-3" *ngIf="data?.context?.target_regions?.length > 0">
        <span>Target Regions</span>
        <p>
          {{ data?.context.target_regions.join(', ') }}
        </p>
      </div>
      <div class="col-3" *ngIf="data?.context?.target_countries?.length > 0">
        <span>Target Countries</span>
        <p>
          {{ data?.context.target_countries.join(', ') }}
        </p>
      </div>

      <div class="col-3" *ngIf="data?.context?.target_oses?.length > 0">
        <span>Target OSes</span>
        <p>
          {{ data?.context.target_oses.join(', ') }}
        </p>
      </div>
      <div class="col-3" *ngIf="data?.context?.target_os_versions?.length > 0">
        <span>Target OS Versions</span>
        <p>
          {{ data?.context.target_os_versions.join(', ') }}
        </p>
      </div>
      <div class="col-3" *ngIf="data?.dependencies?.length > 0">
        <span>Dependencies</span>
        <p>
          {{ data?.dependencies.join(', ') }}
        </p>
      </div>
      <div class="col-3" *ngIf="data?.mapping?.diamond_model">
        <span>Diamond Model</span>
        <p>
          {{ data?.mapping.diamond_model }}
        </p>
      </div>
      <div class="col-3" *ngIf="data?.mapping?.kill_chains?.length > 0">
        <span>Kill Chains</span>
        <p>
          {{ data?.mapping.kill_chains.join(', ') }}
        </p>
      </div>
      <div class="col-3" *ngIf="data?.context?.campaigns?.length > 0">
        <span>Campaigns</span>
        <p>
          {{ data?.context.campaigns.join(', ') }}
        </p>
      </div>
      <div class="col-3" *ngIf="data?.mapping?.exploit_or_vulns?.length > 0">
        <span>Exploits/Vulns</span>
        <p>
          {{ data?.mapping.exploit_or_vulns.join(', ') }}
        </p>
      </div>
      <div class="col-3" *ngIf="data?.context?.operations?.length > 0">
        <span>Operations</span>
        <p>
          {{ data?.context.operations.join(', ') }}
        </p>
      </div>

      <div
        class="col-3"
        *ngIf="data?.mapping?.mitre?.mitre_attack_tactics?.length > 0"
      >
        <span>MITRE ATTACK TACTICS </span>
        <p>
          {{ data?.mapping.mitre.mitre_attack_tactics.join(', ') }}
        </p>
      </div>
      <div
        class="col-3"
        *ngIf="data?.mapping?.mitre?.mitre_attack_techniques?.length > 0"
      >
        <span>Mitre Attack Technique</span>
        <p>
          {{ data?.mapping.mitre.mitre_attack_techniques.join(', ') }}
        </p>
      </div>
      <div class="col-3" *ngIf="data?.mapping?.cwe_ids?.length > 0" ;>
        <span>CWE IDs</span>
        <p>
          {{ data?.mapping.cwe_ids.join(', ') }}
        </p>
      </div>
      <ng-container *ngIf="relatedCollections$ | async as collections">
        <ng-container *ngIf="collections.length > 0">
          <div class="col-12">
            <span>Related Collections</span>
            <p>
              <span *ngFor="let collection of collections; let isLast = last">
                <a (click)="navigateToCollection(collection.UUID)">
                  {{ collection.title }}</a
                ><span>{{ isLast ? '' : ', &nbsp;' }}</span>
              </span>
            </p>
          </div>
        </ng-container>
      </ng-container>
      <div class="col-12" *ngIf="tags">
        <cyborg-facet-buttons
          class="tile-facets"
          [facets]="tags"
          [groupByCategory]="false"
        ></cyborg-facet-buttons>
      </div>
    </div>
  </div>
</div>
